import React, { useCallback, useEffect, useState } from 'react';
import { createUseStyles } from 'react-jss';
import clsx from 'clsx';
import {
  FaFacebook,
  FaTwitter,
  FaInstagram,
  FaPhone,
  FaInbox,
  FaPinterest,
  FaLink,
  FaClock,
  FaEnvelope,
  FaGlobe,
  FaMapMarkerAlt, FaUserPlus, FaUserCheck
} from 'react-icons/fa';
import Button from '../../components/Button';

import Image from 'react-bootstrap/Image';

import { Business as BusinessType, Category } from '../../types';
import Text from '../../components/Text';
import Map from '../../components/Map';
import { getRatingColor } from '../../lib/utils';
import { showLoginModal } from '../../actions/ui';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../config/store';
import { followBusiness, unfollowBusiness } from '../../services/businessService';
import { business } from '../../mocks/api';

export interface BusinessDetailsProps {
  business: BusinessType;
}

const BusinessDetails: React.FC<BusinessDetailsProps> = ({ business }) => {
  const classes = useStyles();
  const [isFollower, setIsFollower] = useState(false);
  const [categories, setCategories] = useState<Category[]>([]);
  const [categoriesCount, setCategoriesCount] = useState(0);
  const isAuthenticated = useSelector<RootState, boolean>(
    (state) => state.auth.isAuthenticated,
  );
  const dispatch = useDispatch();
  useEffect(() => {
    setCategories(business.categories.slice(0, 2))
    setCategoriesCount(business.categories.length <= 2 ? 0 : business.categories.length - 2)
  }, [business])


  const handleUserFollow = useCallback(() => {
    (async () => {
      try {
        if (!isAuthenticated) {
          dispatch(showLoginModal());
          return
        }
        if (isFollower) {
          await unfollowBusiness(+business.id);
        } else {
          await followBusiness(+business.id);
        }
      } catch (e) { }
    })();
  }, [isFollower, business, isAuthenticated]);


  const openNewTab = useCallback((url): void => {
    let win = window.open(url, '_blank');
    win?.focus();
  }, [])
  return (
    <div className={classes.wrapper}>
      <div className={classes.header}>
        <div className={classes.avatarBox}>
          <Image
            className={classes.avatar}
            src={business.logoUrl}
            alt={business.name}
            roundedCircle
          />
        </div>
      </div>
      <div className={classes.content}>

        <Text as="h1" fontSize="size2" align="center" bold>
          {business.name}
        </Text>
        <Text align="center" subText bold>
          {business.industry.name}
        </Text>
        <Text align="center">
          {business.description}
        </Text>
        <div className={classes.divButton}>

          {
            !isFollower ? (
              <Button
                // key={button.id}
                // className={clsx(classes.actionBtn)}
                color="primary"
                size="small"
                onClick={handleUserFollow}
                rounded
              >
                <Text as="span" color="white" bold capitalized>

                  <FaUserPlus className={classes.followIcon} />
                  Follow
                </Text>
              </Button>
            ) : (
              <Button
                // key={button.id}
                className={clsx(classes.followBtn)}
                color="primary"
                size="small"
                onClick={handleUserFollow}
                rounded
              >
                <Text as="span" color="white" bold capitalized>

                  <FaUserCheck className={classes.followIcon} />
                  Following
                </Text>
              </Button>
            )
          }
        </div>



        <div className={classes.categoryBox}>
          {
            categories.map((category) =>
              <div className={classes.categoryTag}>
                <Text as="span">{category.name}</Text>
                <img alt={category.name} className={classes.categoryTagImage} src={category.photo}></img>
              </div>
            )

          }
          {
            categoriesCount > 0 ?
              <div className={classes.categoryTagColor}>
                <Text color="white" as="span">
                  +{categoriesCount}
                </Text>
              </div>
              : null
          }
        </div>
        <div className={classes.ratingBox}>

          <div className={clsx(classes.ratingCard, classes.quality)}
            style={{ backgroundColor: getRatingColor(business.statistics.quality) }}
          >
            <Text color="white" className={classes.ratingName}>Quality</Text>
            <Text color="white" bold className={classes.ratingScore}>{business.statistics.quality.toFixed(1)}</Text>
          </div>
          <div className={clsx(classes.ratingCard, classes.price)}
            style={{ backgroundColor: getRatingColor(business.statistics.price) }}
          >
            <Text color="white" className={classes.ratingName}>Price</Text>
            <Text color="white" bold className={classes.ratingScore}>{business.statistics.price.toFixed(1)}</Text>
          </div>

          {
            business.type == "NORMAL" ?
              <>
                <div className={clsx(classes.ratingCard, classes.service)}
                  style={{ backgroundColor: getRatingColor(business.statistics.service) }}
                >
                  <Text color="white" className={classes.ratingName}>Service</Text>
                  <Text color="white" bold className={classes.ratingScore}>{business.statistics.service.toFixed(1)}</Text>
                </div>

                <div className={clsx(classes.ratingCard, classes.ambiance)}
                  style={{ backgroundColor: getRatingColor(business.statistics.ambiance) }}
                >
                  <Text color="white" className={classes.ratingName}>Ambiance</Text>
                  <Text color="white" bold className={classes.ratingScore}>{business.statistics.ambiance.toFixed(1)}</Text>
                </div>
              </>
              : null
          }
        </div>
        <div className={classes.statsContainer}>
          <div className={classes.statsCard}>
            <Text className={classes.statsNumber} bold>
              {business.statistics.followers}
            </Text>
            <Text className={classes.statsText}>Followers</Text>
          </div>
          {/* <div className={classes.statsCard}>
            <Text className={classes.statsNumber} bold>
            {business.statistics.followers}
            </Text>
            <Text className={classes.statsText}>Following</Text>
          </div> */}
          <div className={classes.statsCard}>
            <Text className={classes.statsNumber} bold>
              {business.statistics.offers}
            </Text>
            <Text className={classes.statsText}>Offers</Text>
          </div>
          <div className={classes.statsCard}>
            <Text className={classes.statsNumber} bold>
              {business.statistics.likes}
            </Text>
            <Text className={classes.statsText}>Likes</Text>
          </div>
        </div>
        <hr />
        <div>
          <Text bold>Contant & Social</Text>
          <div className={classes.socailBox}>

            {business.email ?
              <a href={'mailto:' + business.email}>
                <FaEnvelope className={classes.socialIcon} color="#7E54E1" />
              </a>
              : null}

            {business.phone ?
              <a href={'tel:' + business.phone}>
                <FaPhone className={classes.socialIcon} color="#7E54E1" />
              </a>
              : null}
            {business.facebook && business.facebook != "null" ? <FaFacebook onClick={() => openNewTab(business.facebook)} className={classes.socialIcon} color="#5070A7" /> : null}
            {business.twitter && business.twitter != "null" ? <FaTwitter onClick={() => openNewTab(business.twitter)} className={classes.socialIcon} color="#57AAEE" /> : null}
            {business.instagram && business.instagram != "null" ? <FaInstagram onClick={() => openNewTab(business.instagram)} className={classes.socialIcon} color="#FC84A1" /> : null}
            {business.pinterest && business.pinterest != "null" ? <FaPinterest onClick={() => openNewTab(business.pinterest)} className={classes.socialIcon} color="#C9252A" /> : null}
            {business.website && business.website != "null" ? <FaGlobe onClick={() => openNewTab(business.website)} className={classes.socialIcon} color="#7E54E1" /> : null}
          </div>
        </div>
        <hr />
        {/* <div>
          <Text bold>Working Hours</Text>
          <Text align="left">
            <Text as="span" subText>
              <FaClock size={22} />{' '}
            </Text>
            8:00am - 6:00pm
          </Text>
        </div>
        <hr /> */}
        {business.locations.length > 0 ? (
          <div>
            <Text bold>Location(s)</Text>
            <Text>
              <FaMapMarkerAlt className={classes.socialIcon} />

              {business.locations[0].name}</Text>
            <Map
              mapProps={{
                defaultZoom: 8,
                defaultCenter: {
                  lat: +business.locations[0].latitude,
                  lng: +business.locations[0].longitude,
                },
              }}
              markerProps={{
                position: {
                  lat: +business.locations[0].latitude,
                  lng: +business.locations[0].longitude,
                },
              }}
            />
          </div>
        ) : null}
      </div>
    </div>
  );
};

const useStyles = createUseStyles({
  wrapper: {
    position: 'relative',
  },
  divButton: {
    textAlign: 'center'
  },
  categoryBox: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    marginTop: "8px"
  },
  categoryTag: {
    color: "black",
    margin: "0px 5px",
    padding: "0px 6px",
    fontSize: "13px",
    borderRadius: "13px",
    border: "1px black solid",
    width: "fit-content",
    marginBottom: "7px",
    paddingBottom: "2px"
  },
  categoryTagColor: {
    color: "white",
    padding: "0px 6px",
    backgroundColor: "#522583",
    borderRadius: "13px",
    fontWeight: '500',
    margin: "0px 5px",
    marginBottom: "5px",
    paddingBottom: "2px"
  },
  categoryTagImage: {
    width: "18px",
    height: "18px",
    filter: "brightness(0%) sepia(0) saturate(0) hue-rotate(0deg)"
  },
  header: {
    position: 'relative',
    height: '100px',
  },
  avatarBox: {
    width: '160px',
    height: '160px',
    position: 'absolute',
    left: 0,
    right: 0,
    margin: 'auto',
    top: '-80px',
    zIndex: '1',
  },
  avatar: {
    width: '100%',
    height: '100%',
    border: '8px solid #FFFFFF',
    objectFit: 'cover',
    background:'#FFFFFF',
  },
  content: {
    // marginTop: '100px',
  },
  ratingBox: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    alignItems: 'center',
  },
  ratingCard: {
    padding: '10px',
    borderRadius: '5px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flex: '1',
    margin: '5px',
  },
  '@media (max-width: 768px)': {
    ratingBox: {
      display: "inline-block"
    },
    ratingCard: {
      width: "45%",
      float: "left"
    }
  },
  ratingName: {
    margin: '0',
  },
  ratingScore: {
    margin: '0',
  },
  statsContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
  },
  statsCard: {
    padding: '0.5rem 1rem',
    flex: 1,
    textAlign: 'center',
  },
  statsText: {
    fontSize: '1rem',
    color: '#aaaaaa',
  },
  statsNumber: {
    fontSize: '1.5rem',
  },

  socailBox: {
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
  },
  socialIcon: {
    margin: '5px',
    fontSize: '20px',
    color: '#555555',
    cursor: 'pointer',
  },
  quality: {
    backgroundColor: '#d4f8e8',
  },
  service: {
    backgroundColor: '#d2e7f5',
  },
  price: {
    backgroundColor: '#e3ffcb',
  },
  ambiance: {
    backgroundColor: '#f6e9c8',
  },
  followBtn: {
    backgroundColor: "black"
  },
  followIcon: {
    margin: '0px 3px',
    marginBottom: '3px',
    fontSize: '18px',
    color: 'white'
  }
});

export default BusinessDetails;
